import checkLogin from '@/router/middleware/check-login'
import alreadyLoggedIn from '@/router/middleware/already-logged-in'
import alreadySelectedBase from '@/router/middleware/already-selected-base'

export default {
  checkLogin,
  alreadyLoggedIn,
  alreadySelectedBase,
}
